import React from 'react';
import { Link, Typography } from '@hpi-sox/hpstellar-core';
import { Copilot } from '@hpi-sox/hpstellar-vis-icons';

import { withError } from '../../shared/components/error-boundary';

import useSiteConfig from '../../hooks/useSiteConfig';

import './alliance-badge.less';

function AllianceBadge({ aiBadgeKey, osBadgeKey, variant, seperator, placeholder = true }) {
    const { allianceBadges } = useSiteConfig();

    if (!aiBadgeKey && !osBadgeKey) {
        return null;
    }

    //toggle to enable osbadge feature
    const enableOS = false;

    let badgeData;
    if (Array.isArray(aiBadgeKey)) {
        badgeData = aiBadgeKey.join(',').toLowerCase();
    } else {
        badgeData = aiBadgeKey?.toLowerCase();
    }

    const aiBadge = (allianceBadges || []).find(b => badgeData?.indexOf(b.id) > -1);
    const osBadge = enableOS && (allianceBadges || []).find(b => b.id === osBadgeKey?.toLowerCase());

    let aiIcon;
    if (aiBadge?.label?.trim()?.toLowerCase()?.startsWith('copilot')) {
        aiIcon = <Copilot />;
    } else if (aiBadge) {
        aiIcon = <img src={aiBadge.badge} alt={aiBadge.label} />;
    }

    if (!placeholder && !aiBadge && !osBadge) {
        return null;
    }

    return (
        <>
            <div
                className={`alliance-badge${variant === 'vertical' ? ' alliance-badge-vertical' : ''}
                ${variant === 'small' ? ' alliance-badge-small' : ''}
                ${variant === 'visid-small' ? ' alliance-badge-visid-small' : ''}`}
            >
                {aiBadge && (
                    <span className={`alliance-badge-text${variant === 'title' ? ' alliance-badge-text-title' : ''}`}>
                        {aiIcon}
                        <Typography className="alliance-label" tag="span" variant="caption">
                            {aiBadge.label}
                        </Typography>
                    </span>
                )}
                {osBadge && (
                    <Link
                        className={`alliance-badge-brand-img alliance-badge-img-${osBadge?.id?.replaceAll(' ', '-')}`}
                        to={osBadge.link}
                        variation="body"
                    >
                        <img src={osBadge.badge} alt={osBadge.label} />
                    </Link>
                )}
            </div>
            {enableOS && seperator}
        </>
    );
}

export default withError(AllianceBadge);
